
import Vue from "vue";
import store from "@/store";
import { APPLICATION } from "@/store/applications";
import { createNamespacedHelpers } from "vuex";
import { IApplicationState } from "@/store/applications/types";

const { mapGetters, mapState } = createNamespacedHelpers(
  APPLICATION.NAME_SPACE
);

export default Vue.extend({
  data() {
    return {};
  },
  computed: {
    bankName(): string {
      const banks = store.state.referenceData.banks;
      const bankId =
        store.state.application.applicationData &&
        store.state.application.applicationData.finalDetails &&
        store.state.application.applicationData.finalDetails.bankId;

      return banks && bankId ? banks[bankId].name : "";
    },
    ...mapState({
      bankAccountName: (state: IApplicationState) =>
        state.applicationData &&
        state.applicationData.finalDetails &&
        state.applicationData.finalDetails.bankAccountName,
      bankAccountNumber: (state: IApplicationState) =>
        state.applicationData &&
        state.applicationData.finalDetails &&
        state.applicationData.finalDetails.bankAccountNumber
    }),
    ...mapGetters([APPLICATION.GETTERS.IS_EDITABLE])
  },
  methods: {},
  validations: {}
});
